import api from '../../../api.js';

export const types = {
  START_LOADING: 'Secteurs/startLoading',
  STOP_LOADING: 'Secteurs/stopLoading',
  SET_SECTEURS: 'Secteurs/setSecteurs',
};

function startLoading() {
  return {
    type: types.START_LOADING
  };
}

function stopLoading() {
  return {
    type: types.STOP_LOADING
  };
}

export function setSecteurs(secteurs) {
  return {
    type: types.SET_SECTEURS,
    secteurs
  };
}

export default function loadSecteurs() {
  return async (dispatch) => {
    dispatch(startLoading());
    try {
      const secteurs = (await api.secteurs.getAll()).data;
      dispatch(setSecteurs(secteurs));
    } catch (e) {
      console.warn(e);
    } finally {
      dispatch(stopLoading());
    }
  }
}